import { combineReducers } from 'redux'
import carSteelRim from './CarSteelRimSearch/carSteelRimSearchSlice'

export default combineReducers({
	carSteelRim
})